import { useContext, useCallback } from "react";

import Swal from "sweetalert2";

import { useHistory } from "react-router";

import { validNotNull } from "../../../../utils/validations";
import { sendRpa } from "../../../../repository/ERP/rpa/RpaService";
import { formatDate } from "../../../../utils/formatDate";
import { FornecedorContext } from "../contexts/FornecedorContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import MaskService from "../../../../utils/mask/maskService";
import {
  createFornecedor,
  deleteFornecedor,
  updateFornecedor,
} from "../../../../repository/ERP/prouser/FornecedorService";
import { notify } from "../../../../utils/notify";
import {
  findByCEP,
  findByCNPJ,
  findByCPF,
} from "../../../../repository/services/BigDataService";
import { findNotas } from "../../../../repositories/qerpapi/erp/nf/v1/NotafiscalRepository";
import { findFornecedorByCpfCnpj } from "../../../../repositories/qerpapi/erp/prouser/v1/FornecedoresRepository";
import { GlobalVariables } from "../../../../GlobalVariables";

export default function useFornecedoresTelaController() {
  const { listUf, listCounty } = useContext(FornecedorContext);

  const {
    //Contato
    contacts,
    setContacts,

    //Geral
    geralCpfcnpj,
    setGeralCpfCnpj,
    geralRazao,
    setGeralRazao,
    geralFantasia,
    setGeralFantasia,
    geralCep,
    setGeralCEP,
    geralEndereco,
    setGeralEndereco,
    geralNumero,
    setGeralNumero,
    geralComplemento,
    setGeralComplemento,
    geralBairro,
    setGeralBairro,
    geralEstado,
    setGeralEstado,
    geralMunicipio,
    setGeralMunicipio,
    geralPais,
    setGeralDdd,
    geralTel,
    setGeralTel,
    geralEmail,
    setGeralEmail,
    geralIe,
    setGeralIe,
    geralSm,
    setGeralSm,
    geralIm,
    setGeralIm,
    setGeralTipoInscricao,
    setGeralErrors,
    geralCustomerId,
    setGeralCustomerId,
    setGeralPais,
    geralCf,
    setGeralCf,
    geralAtivo,
    providerType,
    setProviderType,
    integrationConectionCod,
    setIntegrationConectionCod,
    integrationDueDate,
    setIntegrationDueDate,
    integrationCpfcnpj,
    setIntegrationCpfCnpj,
    IeIndication,
    setIeIndication,
    geralCelular,
    geralWhatsappAtivo,
    setRuralProducer,
    ruralProducer,
    setValidCpfCnpj,

    //Outros
    bank,
    setBank,
    previsao,
    setPrevisao,
    classificacao,
    setClassificacao,
    grupoEconomico,
    setGrupoEconomico,
    observacao,
    setObservacao,

    // Estabelecimentos Rurais
    setRuralEstablishment,
    ruralEstablishment,

    //Tela
    setInitialDate,
    setFinalDate,
    setDataRows,
    setLoading,

    //Funcoes
    setExpanded,
  } = useContext(FornecedorContext);

  const optionsSetters = {
    general: {
      setTypeSubscription: setGeralTipoInscricao,
      setCpfCnpj: setGeralCpfCnpj,
      setName: setGeralRazao,
      setFantasy: setGeralFantasia,
      setCep: setGeralCEP,
      setAddress: setGeralEndereco,
      setNumber: setGeralNumero,
      setComplement: setGeralComplemento,
      setDistrict: setGeralBairro,
      setUf: setGeralEstado,
      setCounty: setGeralMunicipio,
      setDdd: setGeralDdd,
      setTelephone: setGeralTel,
      setEmail: setGeralEmail,
      setIe: setGeralIe,
      setSimpleNational: setGeralSm,
      setIm: setGeralIm,
    },
  };

  const { queryParams } = useContext(QueryParamsContext);

  const { push, go } = useHistory();

  const deleteSupplierHandler = async (id, setLoading = () => {}) => {
    try {
      const callback = await deleteFornecedor(id, queryParams.empresa_cnpj);

      if (callback && callback.success) {
        notify("Fornecedor excluído com sucesso!", true, "success");
      } else {
        notify("Ocorreu um erro ao excluir o fornecedor.");
      }

      return callback;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleCidade = useCallback(
    (prop) => {
      setGeralMunicipio(prop);
    },
    [setGeralMunicipio]
  );

  const handleTipoInscricao = useCallback(
    (prop) => {
      setGeralTipoInscricao(prop);
      setGeralCpfCnpj("");
    },
    [setGeralTipoInscricao, setGeralCpfCnpj]
  );

  const handleChangeCep = (e, context, settersProp) => {
    const setters = settersProp || optionsSetters[context];

    setters.setCep(MaskService.toMask("cep", e.target.value));

    if (
      e.target.value.length === 10 ||
      MaskService.toMask("cep", e.target.value).length === 10
    ) {
      document.activeElement.blur();
      handleFindByCepHub(e.target.value, context, settersProp);
    }
  };

  const handleFindByCepHub = async (cep, context, settersProp) => {
    try {
      setLoading(true);
      const setters = settersProp || optionsSetters[context];

      const response = await findByCEP(cep);
      const responseData = response?.data;

      if (
        response.success &&
        responseData.statusCode === 200 &&
        responseData.data
      ) {
        setters.setUf(
          (current) =>
            listUf.find((opt) => opt.estado === responseData.data.stateCode) ||
            current
        );
        setters.setAddress((current) => responseData.data.street || current);
        setters.setDistrict(
          (current) => responseData.data.neighborhood || current
        );
        setters.setComplement(
          (current) => responseData.data.additionalInfo || current
        );
        setters.setCounty(
          (current) =>
            listCounty.find(
              (opt) => opt.codigo === responseData.data.ibgeCode
            ) || current
        );
        return;
      }

      notify("CEP não encontrado.");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleNumInscricao = (inputValue) => {
    const getData = async () => {
      try {
        setLoading(true);
        const providerExists = await findFornecedorByCpfCnpj(
          queryParams.empresa_cnpj,
          inputValue.replace(/[^0-9]+/g, "")
        );
        if (
          providerExists.success &&
          providerExists.data.length &&
          (providerExists.data || []).find(
            (current) => current.id !== geralCustomerId
          )
        ) {
          setGeralCpfCnpj("");
          return notify("Já existe um Fornecedor com este Nº de inscrição.");
        }

        const response = await findByCNPJ(inputValue);
        const responseData = response?.data;

        if (
          response.success &&
          responseData.statusCode === 200 &&
          responseData.data
        ) {
          setGeralRazao(
            (responseData.data.corporate_name || "").substring(0, 50)
          );

          handleChangeCep(
            { target: { value: responseData.data.addresses[0].postalCode } },
            "general"
          );
          setGeralEndereco(responseData.data.addresses[0]?.street);
          setGeralBairro(responseData.data.addresses[0]?.bairro);
          const tel = responseData.data.phones[0]?.number
            ? responseData.data.phones[0].number.replace(/[^0-9]+/g, "")
            : "";
          setGeralComplemento(responseData.data.addresses[0].additionalInfo);
          setGeralFantasia(
            (
              responseData.data.commercial_name ||
              responseData.data.corporate_name ||
              ""
            ).substring(0, 20)
          );
          setGeralNumero(responseData.data.addresses[0]?.number);
          setGeralDdd(tel ? tel.substring(0, 2) : "");
          setGeralTel(tel ? tel : "");
          setGeralEmail(responseData.data.emails[0]?.email);
          return;
        }
        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } catch (error) {
        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } finally {
        setLoading(false);
      }
    };

    if (inputValue.length === 18) {
      getData();
    }
  };

  const handleInitialDateChange = (initialDate) => {
    setInitialDate(initialDate);
  };

  const handleFinalDateChange = (finalDate) => {
    setFinalDate(finalDate);
  };

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const handleRemoveItemTable = useCallback(
    (setRows, setDataTable, list, index) => {
      Swal.fire({
        icon: "question",
        text: "Tem certeza que deseja remover este registro?",
        showConfirmButton: true,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const copy = [...list];
          copy.splice(index, 1);
          setRows(copy);
          setDataTable(copy);
        }
      });
    },
    []
  );

  const handleEditItemTable = useCallback(
    (setOpen, setRowEdit, data = {}, index = -1) => {
      setOpen(true);
      setRowEdit({ data, index });
    },
    []
  );

  //Funcao de click do botao buscar. Pega os dados na api e joga pra um variavel
  //que armazena dados da tabela na view
  const getDataTable = () => {
    try {
      setLoading(true);
      (async () => {
        const callback = await findNotas(queryParams.empresa_cnpj);
        setDataRows(callback.data);
        setLoading(false);
      })();
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleSubmit = async (again) => {
    if (geralWhatsappAtivo && !geralCelular)
      return notify("Não é possível ativar o Whatsapp sem número de celular");

    setLoading(true);
    let cpfl = false;
    var sn = "N";
    var cf = "0";
    var active = "N";
    if (geralSm) {
      sn = "S";
    }
    if (geralCf) {
      cf = "1";
    }
    if (geralAtivo) {
      active = "S";
    }
    const tel = geralTel ? geralTel.replace(/[^0-9]+/g, "") : "";

    const required = [
      { value: geralCpfcnpj, key: "geralCpfcnpj" },
      { value: geralNumero, key: "geralNumero" },
      { value: geralRazao, key: "geralRazao" },
      { value: geralFantasia, key: "geralFantasia" },
      { value: geralMunicipio, key: "geralMunicipio" },
      { value: geralEndereco, key: "geralEndereco" },
      { value: geralPais, key: "geralPais" },
      { value: geralBairro, key: "geralBairro" },
      { value: geralEstado, key: "geralEstado" },
      { value: sn, key: "geralSm" },
    ];
    if (providerType?.id !== 1) {
      cpfl = true;
      required.push(
        { value: integrationDueDate, key: "integrationDueDate" },
        { value: integrationConectionCod, key: "integrationConectionCod" }
      );
    }
    if (
      geralCep &&
      !MaskService.isValid("cep", geralCep) &&
      geralEstado?.codibge !== GlobalVariables.state.external
    ) {
      required.push({ value: geralCep, key: "geralCep" });
    }
    let resultValidation = validNotNull(required),
      registrationType = null,
      cpfCnpjReplaced = geralCpfcnpj.replace(/[^0-9]+/g, "");

    if (cpfCnpjReplaced.length === 11) {
      registrationType = "cpf";
    } else if (cpfCnpjReplaced.length === 14) registrationType = "cnpj";

    if (!geralCustomerId) {
      const resultSubscription = await findFornecedorByCpfCnpj(
        queryParams.empresa_cnpj,
        cpfCnpjReplaced
      );

      if (resultSubscription?.data?.length) {
        resultSubscription?.data.forEach((result) => {
          if (result?.cgc?.replace(/[^0-9]+/g, "") === cpfCnpjReplaced) {
            resultValidation.error = true;
            resultValidation.errorsValidation.geralCpfcnpj = `${
              registrationType ? registrationType.toUpperCase() : "CPF"
            } já utilizado em outro cliente.`;
          }
        });
      }
    }

    if (resultValidation.error) {
      setGeralErrors(resultValidation.errorsValidation);
      setLoading(false);
      return notify("Verifique se os campos obrigatórios estão preenchidos.");
    }

    if (ruralProducer && !ruralEstablishment?.length) {
      setLoading(false);
      return notify(
        "Estabelecimento Rural é obrigatório para Produtor Rural.",
        true,
        "warning"
      );
    }

    const submitDataGeral = {
      fornecedor: {
        razao: (geralRazao ?? "").substring(0, 50),
        apelido: (geralFantasia ?? "").substring(0, 20),
        endereco: geralEndereco,
        bairro: geralBairro,
        cidade: geralMunicipio.municipio,
        cep: geralCep.replace(/[^0-9]+/g, ""),
        ddd1: tel ? tel.substring(0, 2) : "",
        telefone1: tel ? tel.substring(2) : "",
        email1: geralEmail,
        id_estado: Number(geralEstado.id),
        ie: geralIe,
        cgc: cpfCnpjReplaced,
        simples_nacional: sn,
        idpais: Number(geralPais.codigo),
        inscricao_municipal: geralIm,
        numero: geralNumero,
        complemento: geralComplemento,
        municipio_codigo: geralMunicipio.codigo,
        homepage: "www.qyon.com",
        ativo: active,
        produtor_rural: ruralProducer ? 1 : 0,
        previsaoentrega: previsao,
        observacao: observacao,
        idclassificacao: classificacao ? classificacao.id : null,
        cnpjmatriz: grupoEconomico,
        contatos: contacts,
        contasbancarias: bank,
        consumidorfinal: cf,
        id_fornecedor_servico: providerType ? providerType.id : 1,
        ultimo_vencimento: cpfl ? integrationDueDate : null,
        codigo_ligacao: integrationConectionCod,
        cpfcnpjservico: integrationCpfcnpj.replace(/[^0-9]+/g, ""),
        indiedest: (IeIndication?.value || "").toString() || "9",
        celular: geralCelular,
        whatsapp_ativo: geralWhatsappAtivo ? 1 : 0,

        // Estabelecimentos Rurais
        estabelecimentosRurais: ruralEstablishment,
      },
    };
    var returnApi;
    if (geralCustomerId) {
      returnApi = await updateFornecedor(
        geralCustomerId,
        queryParams.empresa_cnpj,
        submitDataGeral
      );
    } else {
      returnApi = await createFornecedor(
        queryParams.empresa_cnpj,
        submitDataGeral,
        "contatos,contasbancarias"
      );
    }

    setLoading(false);
    if (returnApi.success) {
      if (again) {
        push("cadastro?empresa_cnpj=" + queryParams.empresa_cnpj, null);
        go(0);
        return notify("Fornecedor Cadastrado com Sucesso", true, "success");
      } else {
        return notify(
          "Fornecedor Cadastrado com Sucesso",
          true,
          "success",
          push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj)
        );
      }
    } else {
      const errorMessage =
        returnApi?.message || "Erro ao Cadastrar/Atualizar o Fornecedor";
      return notify(errorMessage);
    }
  };

  const handleCreateModalFornecedor = async (
    setOpen = () => {},
    handleSelectSupplier = () => {}
  ) => {
    try {
      if (geralWhatsappAtivo && !geralCelular)
        return notify("Não é possível ativar o Whatsapp sem número de celular");

      setLoading(true);
      let cpfl = false;
      let sn = "N";
      let cf = "0";
      let active = "N";
      if (geralSm) {
        sn = "S";
      }
      if (geralCf) {
        cf = "1";
      }
      if (geralAtivo) {
        active = "S";
      }
      const tel = geralTel ? geralTel.replace(/[^0-9]+/g, "") : "";

      const required = [
        { value: geralCpfcnpj, key: "geralCpfcnpj" },
        { value: geralNumero, key: "geralNumero" },
        { value: geralRazao, key: "geralRazao" },
        { value: geralFantasia, key: "geralFantasia" },
        { value: geralMunicipio, key: "geralMunicipio" },
        { value: geralEndereco, key: "geralEndereco" },
        { value: geralPais, key: "geralPais" },
        { value: geralBairro, key: "geralBairro" },
        { value: geralEstado, key: "geralEstado" },
        { value: sn, key: "geralSm" },
      ];
      if (providerType?.id !== 1) {
        cpfl = true;
        required.push(
          { value: integrationDueDate, key: "integrationDueDate" },
          { value: integrationConectionCod, key: "integrationConectionCod" }
        );
      }
      if (
        geralCep &&
        !MaskService.isValid("cep", geralCep) &&
        geralEstado?.codibge !== GlobalVariables.state.external
      ) {
        required.push({ value: geralCep, key: "geralCep" });
      }
      let resultValidation = validNotNull(required),
        registrationType = null,
        cpfCnpjReplaced = geralCpfcnpj.replace(/[^0-9]+/g, "");

      if (cpfCnpjReplaced.length === 11) {
        registrationType = "cpf";
      } else if (cpfCnpjReplaced.length === 14) registrationType = "cnpj";

      if (!geralCustomerId) {
        const resultSubscription = await findFornecedorByCpfCnpj(
          queryParams.empresa_cnpj,
          cpfCnpjReplaced
        );

        if (resultSubscription?.data?.length) {
          resultSubscription?.data.forEach((result) => {
            if (result?.cgc?.replace(/[^0-9]+/g, "") === cpfCnpjReplaced) {
              resultValidation.error = true;
              resultValidation.errorsValidation.geralCpfcnpj = `${
                registrationType ? registrationType.toUpperCase() : "CPF"
              } já utilizado em outro cliente.`;
            }
          });
        }
      }

      if (resultValidation.error) {
        setGeralErrors(resultValidation.errorsValidation);
        setLoading(false);
        return notify("Verifique se os campos obrigatórios estão preenchidos.");
      }

      setGeralErrors({});

      const submitDataGeral = {
        fornecedor: {
          razao: (geralRazao ?? "").substring(0, 50),
          apelido: (geralFantasia ?? "").substring(0, 20),
          endereco: geralEndereco,
          bairro: geralBairro,
          cidade: geralMunicipio.municipio,
          cep: geralCep.replace(/[^0-9]+/g, ""),
          ddd1: tel ? tel.substring(0, 2) : "",
          telefone1: tel ? tel.substring(2) : "",
          email1: geralEmail,
          id_estado: Number(geralEstado.id),
          ie: geralIe,
          cgc: cpfCnpjReplaced,
          simples_nacional: sn,
          idpais: Number(geralPais.codigo),
          inscricao_municipal: geralIm,
          numero: geralNumero,
          complemento: geralComplemento,
          municipio_codigo: geralMunicipio.codigo,
          homepage: "www.qyon.com",
          ativo: active,
          previsaoentrega: previsao,
          observacao: observacao,
          idclassificacao: classificacao ? classificacao.id : null,
          cnpjmatriz: grupoEconomico,
          contatos: contacts,
          contasbancarias: bank,
          consumidorfinal: cf,
          id_fornecedor_servico: providerType ? providerType.id : 1,
          ultimo_vencimento: cpfl ? integrationDueDate : null,
          codigo_ligacao: integrationConectionCod,
          cpfcnpjservico: integrationCpfcnpj.replace(/[^0-9]+/g, ""),
          indiedest: (IeIndication?.value || "").toString() || "9",
          celular: geralCelular,
          whatsapp_ativo: geralWhatsappAtivo ? 1 : 0,
        },
      };
      let returnApi;
      if (geralCustomerId) {
        returnApi = await updateFornecedor(
          geralCustomerId,
          queryParams.empresa_cnpj,
          submitDataGeral,
          "contatos,contasbancarias"
        );
      } else {
        returnApi = await createFornecedor(
          queryParams.empresa_cnpj,
          submitDataGeral,
          "contatos,contasbancarias"
        );
      }

      if (!returnApi.success) {
        return notify("Erro ao cadastrar o Fornecedor");
      }

      handleSelectSupplier(() => {}, [returnApi.data]);
      setOpen(false);
    } catch (error) {
      console.error(`Erro ao cadastrar fornecedor. Detalhes: ${error}`);
      return notify("Erro ao cadastrar o Fornecedor");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSupplier = (
    id,
    setViewLoading = () => {},
    setReload = () => {},
    enableToDelete = true
  ) => {
    if (!enableToDelete) return notify("Fornecedor não pode ser excluído");
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir o fornecedor?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setViewLoading(true);
        const callback = await deleteSupplierHandler(id, setViewLoading);
        if (!callback?.success) return;

        setViewLoading(false);
        setReload((old) => !old);
      }
    });
  };

  const handleDeleteSupplierContact = async (id) => {
    const result = await Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir o contato?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    });

    if (result.isConfirmed) {
      const newContacts = [...contacts].filter((contact) => contact?.id !== id);
      setContacts(newContacts);
    }
  };

  const handleDeleteSupplierBankAcoount = async (item) => {
    if (item.conta_padrao) {
      notify(
        "Atribua outra informação financeira como principal antes de excluir"
      );
      return;
    }

    const result = await Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir a informação financeira?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    });

    if (result.isConfirmed) {
      const newBank = [...bank].filter((bank) => bank?.id !== item.id);
      setBank(newBank);
    }
  };

  const clear = useCallback(() => {
    setContacts([]);
    setBank([]);
    setGeralCustomerId(null);
    setGeralCpfCnpj("");
    setGeralRazao("");
    setGeralFantasia("");
    setGeralCEP("");
    setGeralEndereco("");
    setGeralNumero("");
    setGeralComplemento("");
    setGeralBairro("");
    setGeralEstado(null);
    setGeralMunicipio(null);
    setGeralPais({
      codigo: "1058",
      descricao: "BRASIL",
      siscomex: "105",
    });
    setGeralDdd("");
    setGeralTel("");
    setGeralEmail("");
    setGeralIe("");
    setGeralSm(false);
    setGeralCf(false);
    setGeralIm("");
    setGeralTipoInscricao({ descricao: "CNPJ" });
    setPrevisao("");
    setClassificacao(null);
    setGrupoEconomico("");
    setObservacao("");
    setIntegrationDueDate(
      formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
    );
    setIntegrationConectionCod("");
    setProviderType({
      descricao: "Nenhum",
      id: 1,
    });
    setIeIndication(null);
    setGeralErrors({});
    setRuralProducer(false);
    setRuralEstablishment([]);
    setValidCpfCnpj(false);
  }, [
    setBank,
    setClassificacao,
    setContacts,
    setGeralBairro,
    setGeralCEP,
    setGeralCf,
    setGeralComplemento,
    setGeralCpfCnpj,
    setGeralCustomerId,
    setGeralDdd,
    setGeralEmail,
    setGeralEndereco,
    setGeralErrors,
    setGeralEstado,
    setGeralFantasia,
    setGeralIe,
    setGeralIm,
    setGeralMunicipio,
    setGeralNumero,
    setGeralPais,
    setGeralRazao,
    setGeralSm,
    setGeralTel,
    setGeralTipoInscricao,
    setGrupoEconomico,
    setIeIndication,
    setIntegrationConectionCod,
    setIntegrationDueDate,
    setObservacao,
    setPrevisao,
    setProviderType,
    setRuralProducer,
    setRuralEstablishment,
    setValidCpfCnpj,
  ]);

  const handleCancelSubmit = () => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja cancelar?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj);
      }
    });
  };

  const handleBackSubmit = () => {
    push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj);
  };

  const handleChangeIntegrationCpfCnpj = (e) => {
    let mask = "cnpj";
    if (e.target.value.length <= 14) {
      mask = "cpf";
    }
    setIntegrationCpfCnpj(MaskService.toMask(mask, e.target.value));
  };

  const sendRpaFornecedor = async () => {
    try {
      setLoading(true);
      const response = await sendRpa(
        queryParams.empresa_cnpj,
        integrationCpfcnpj.replace(/[^0-9]+/g, "")
      );
      Swal.fire({
        icon: response.success ? "success" : "error",
        text: response.msg,
        showConfirmButton: true,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return {
    handleCidade,
    handleTipoInscricao,
    handleNumInscricao,
    handleChangeCep,
    handleFinalDateChange,
    handleInitialDateChange,
    handleDeleteSupplier,
    handleDeleteSupplierContact,
    handleDeleteSupplierBankAcoount,
    getDataTable,
    handleSubmit,
    handleCancelSubmit,
    handleBackSubmit,
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
    deleteSupplierHandler,
    handleChangeIntegrationCpfCnpj,
    sendRpaFornecedor,
    clear,
    handleCreateModalFornecedor,
  };
}
